module.exports = __webpack_public_path__ + "files/b4e6b7907220d9dee4ae33df62d857f9.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Arvo-regular.ttf
// module id = 603
// module chunks = 60